import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { TASKS_URL } from "./api-url.constants";

export const deleteTask = async (taskId: string): Promise<void> => {
  await typedFetch(`${TASKS_URL}/${taskId}`, {
    method: API_METHODS.DELETE,
  });
};
